// extracted by mini-css-extract-plugin
export default {"label":"Radio_label__8hk9c","checkmark":"Radio_checkmark__KjKAY"};